module.exports = __webpack_public_path__ + "static/glorious_0-45f40a0fccc183031a71c47a8d6445be.png";